export function isMobileDevice() {
  return navigator?.userAgent !== ''
    ? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    : false;
}

export const Platforms = {
  ANDROID: 'Android',
  IOS: 'iOS',
};
